import { Helmet } from 'react-helmet';
import { Button, Icon } from '@/components/ui';
import useLadyService from '../../../services/LadyService';
import { Popup } from '../index';

const ConfirmDeletePopup = (props) => {
	const { open, setOpen, onSubmit } = props;

	const { t } = useLadyService();

	const handleCloseDelete = () => {
		setOpen(false);
	};

	return (
		<Popup
			open={open}
			setOpen={handleCloseDelete}
			container={'div'}
			clazz={'gap-16'}
		>
			<h2>{t('disforsure')}?</h2>

			<div className="fd-column gap-16 ">
				<Button
					clazz={'button--green justify-center w-100'}
					onClick={handleCloseDelete}
				>
					{t('cancel')}
				</Button>

				<Button
					buttonType={'submit'}
					clazz={'button--error justify-center w-100'}
					onClick={onSubmit}
				>
					{t('yes')}, {t('disconnect')}
				</Button>
			</div>
		</Popup>
	);
};

export default ConfirmDeletePopup;
